import React from 'react';
import PropTypes from 'prop-types';

import PeriodDates from './PeriodDates';

const ExtractBlock = ({ initialValues, config, onSubmit, strings, dateFormat }) => {
  const getBlock = (cfg, idx) => {
    switch (cfg.type) {
      case 'periodDates':
        return (
          <PeriodDates
            key={`periodDates_${idx}`}
            initialValues={initialValues}
            fields={cfg.fields}
            onSubmit={onSubmit}
            strings={strings}
            dateFormat={dateFormat}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <div className="extract-block">
      <h3 className="md-title md-cell md-cell--12 title">{strings[config.title]}</h3>
      {getBlock(config)}
    </div>
  );
};

ExtractBlock.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  config: PropTypes.object,
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  dateFormat: PropTypes.string,
};

ExtractBlock.defaultProps = {
  strings: {},
  config: {},
  initialValues: {},
  onSubmit: () => {},
  dateFormat: 'dd/MM/yyyy',
};

export default ExtractBlock;
